import Link from 'next/link'
import React, { useState } from 'react'
import useAmplitude from '../../../contexts/AmplitudeContext'
import Button from '../../ui-kit/buttons/Button'
import Header from '../../ui-kit/header/Header'


export interface HomeJumbotronProps {

}
const HomeJumbotron: React.FC<HomeJumbotronProps> = (props) => {
  const { amplitude } = useAmplitude();
  const testAmplitude = e => {
    amplitude.logEvent('click_button_portafolio_home');
  }

  return (
    <div className="bg-solid-blue rounded-lg p-4 xl:p-8" >
      <>
        {/* Mobile */}
        <div className="xl:hidden">
          <div className="flex justify-center mb-4 p-4 md:p-8">
            <img src="/imgs/slide_01.png" alt="alt-image" className="w-3/4 h-auto" />
          </div>
          <div className="space-y-4">
            <Header as="h2" className="text-white">Crear un portafolio profesional</Header>
            <Header as="h4" className="text-white">
              Creando  proyectos de alto impacto que te ayudarán a encontrar tu primer empleo. Deja que la comunidad te dé sus opiniones sobre tu código.
            </Header>
            <Link href="/proyectos">
              <Button size="md" block type="primary" >
                Encontrar Proyecto
              </Button>
            </Link>
            {/* <Link href="/blog/que-es-un-portafolio">
              <div className="text-center">
                <span role="img" aria-details="thinking emoji">🤔</span><span className="text-highlight-yellow underline ml-2">¿Qué es un portafolio?</span>
              </div>
            </Link> */}
          </div>
        </div>
        {/* Desktop */}
        <div className="hidden xl:flex">
          <div className="space-y-4 w-3/5">
            <h1 className="text-3xl font-extrabold font-sans text-white leading-8">
              Crea un portafolio profesional
            </h1>
            <Header as="h4" className="text-gray-200 font-normal">
              Creando  proyectos de alto impacto que te ayudarán a encontrar tu primer empleo. Deja que la comunidad te dé sus opiniones sobre tu código.
            </Header>
            <Link href="/proyectos">
              <Button size="lg" type="primary" onClick={testAmplitude}>
                Encontrar Proyecto
              </Button>
            </Link>
            {/* <Link href="/blog/que-es-un-portafolio">
              <div className="">
                <span role="img" aria-details="thinking emoji">🤔</span><span className="text-white underline ml-1">¿Qué es un portafolio?</span>
              </div>
            </Link> */}
          </div>
          <div className="flex justify-center p-4 w-2/5">
            <img src="/imgs/slide_01.png" alt="alt-image" />
          </div>
        </div>
      </>
    </div>
  )
}


export default HomeJumbotron;